/* eslint-disable */ import { $DomainEntityReflection, EnhancedAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
import { Deck, DeckSection, FixingSystem, Handrail, HandrailEnd, Post, Stairs } from './model/index.js';
export const constants = {
    DeckItem: {},
    DeckSection: {},
    Deck: {
        $linkProductSku: 'BDL-01',
        $maxBalustradeSectionLength: 10000,
        $maxPostDistance: 1500,
        $maxHandrailLength: 6000,
        $postWidth: 50,
        $postHeight: 956
    },
    HandrailEnd: {},
    ProjectedEntity: {},
    Stairs: {}
};
const DeckItemExpressions = [
    '$balustrades',
    '$posts',
    '$fixingSystems',
    '$handrails',
    '$projectedEntityRecipes',
    '$parts',
    '$partObjects',
    '$skus',
    '$deleteFab',
    '$deck',
    '$projectedEntities'
];
const DeckSectionExpressions = [
    '$centerX',
    '$levelHeight'
];
const DeckExpressions = [
    '$postSize',
    '$numberOfWires',
    '$shapeHeights',
    '$boundingBox',
    '$isStainless',
    '$postShape',
    '$allSkus',
    '$handrailSkus',
    '$wireSkus',
    '$otherSkus',
    '$wireProducts',
    '$handrailProducts',
    '$otherProducts',
    '$linkProduct',
    '$products',
    '$productsForCart',
    '$summary',
    '$price',
    '$finishSwatches',
    '$thinIntermediatePostSwatches',
    '$sketchingRecipes',
    '$items',
    '$linkProductSku',
    '$maxBalustradeSectionLength',
    '$maxPostDistance',
    '$maxHandrailLength',
    '$postWidth',
    '$postHeight',
    '$violations'
];
const FixingSystemExpressions = [
    '$fixingSystemType',
    '$finishType',
    '$numberOfWires',
    '$wireSkuLength',
    '$wireSkuLengthMetadata',
    '$partSkus',
    '$offsetFromBottom',
    '$fixingSystemPositionType',
    '$fixingSystemAttachementType',
    '$fixingSystemAttachementData',
    '$flatParts',
    '$obtuseRoundParts',
    '$obtuseSquareRotatedParts',
    '$obtuseSquareAdaptorParts',
    '$stairsSimpleParts',
    '$stairsRotatedParts',
    '$stairsAdaptorParts'
];
const HandrailExpressions = [
    '$handrailPartData',
    '$numberOfHandrailSkus',
    '$skuLength',
    '$handrailSkuMetadata',
    '$handrailSkus'
];
const ProjectedEntityExpressions = [
    '$postType',
    '$postShape',
    '$postSize',
    '$postStyle',
    '$postFinish',
    '$handrailType',
    '$parts',
    '$partObjects',
    '$skus',
    '$deckItem'
];
const PostExpressions = [
    '$thinIntermediatePostType'
];
const StairsExpressions = [
    '$height',
    '$centerX',
    '$depth',
    '$slope',
    '$centerZ',
    '$levelHeight'
];
const HandrailEndExpressions = [
    '$selectionFilter'
];
export const $Deck = new $DomainEntityReflection('Deck', [
    ...DeckExpressions
]);
export const $DeckSection = new $DomainEntityReflection('DeckSection', [
    ...DeckSectionExpressions,
    ...DeckItemExpressions
]);
export const $Stairs = new $DomainEntityReflection('Stairs', [
    ...StairsExpressions,
    ...DeckItemExpressions
]);
export const $Post = new $DomainEntityReflection('Post', [
    ...PostExpressions,
    ...ProjectedEntityExpressions
]);
export const $FixingSystem = new $DomainEntityReflection('FixingSystem', [
    ...FixingSystemExpressions,
    ...ProjectedEntityExpressions
]);
export const $Handrail = new $DomainEntityReflection('Handrail', [
    ...HandrailExpressions,
    ...ProjectedEntityExpressions
]);
export const $HandrailEnd = new $DomainEntityReflection('HandrailEnd', [
    ...HandrailEndExpressions,
    ...ProjectedEntityExpressions
]);
export const $AnyDomainEntity = new EnhancedAliasReflection('$AnyDomainEntity', [
    Deck.type,
    DeckSection.type,
    Stairs.type,
    Post.type,
    FixingSystem.type,
    Handrail.type,
    HandrailEnd.type
]);
export const $RootEntity = new EnhancedAliasReflection('$RootEntity', [
    Deck.type
]);
export const $DeckItem = new EnhancedAliasReflection('$DeckItem', [
    DeckSection.type,
    Stairs.type
]);
export const $ProjectedEntity = new EnhancedAliasReflection('$ProjectedEntity', [
    Post.type,
    FixingSystem.type,
    Handrail.type,
    HandrailEnd.type
]);
export const $entityReflections = {
    Deck: $Deck,
    DeckSection: $DeckSection,
    Stairs: $Stairs,
    Post: $Post,
    FixingSystem: $FixingSystem,
    Handrail: $Handrail,
    HandrailEnd: $HandrailEnd
};

//# sourceMappingURL=enhanced-model.js.map